import React, { createContext, useState } from 'react';

export const SignupContext = createContext();

const readSession = (key, fallback) => {
    try {
        const value = sessionStorage.getItem(key);
        if (value === null) return fallback;
        return JSON.parse(value);
    } catch {
        return fallback;
    }
};

const writeSession = (key, value) => {
    try {
        if (value === null || value === undefined || value === '') {
            sessionStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
    } catch {
        // ignore storage errors
    }
};

export const SignupProvider = ({ children }) => {
    const [APIformData, setAPIFormDataState] = useState(() => readSession('hs_signup_form', {}));
    const [userName, setUserNameState] = useState(() => readSession('hs_signup_name', 'Guest'));
    const [otp, setOtp] = useState('');
    const [isOtpSent, setIsOtpSentState] = useState(() => readSession('hs_signup_otp', false));
    const [userId, setUserIdState] = useState(() => readSession('hs_signup_userId', null));
    const [isLoggedIn, setIsLoggedInState] = useState(() => readSession('hs_signup_loggedIn', false));

    const setAPIFormData = (data) => {
        setAPIFormDataState(data);
        writeSession('hs_signup_form', data);
    };

    const setUserName = (name) => {
        setUserNameState(name);
        writeSession('hs_signup_name', name);
    };

    const setIsOtpSent = (value) => {
        setIsOtpSentState(value);
        writeSession('hs_signup_otp', value);
    };

    const setUserId = (id) => {
        setUserIdState(id);
        writeSession('hs_signup_userId', id);
    };

    const setIsLoggedIn = (value) => {
        setIsLoggedInState(value);
        writeSession('hs_signup_loggedIn', value);
    };

    const clearSignup = () => {
        setAPIFormDataState({});
        setUserNameState('Guest');
        setOtp('');
        setIsOtpSentState(false);
        setUserIdState(null);
        setIsLoggedInState(false);
        try {
            [
                'hs_signup_form',
                'hs_signup_name',
                'hs_signup_otp',
                'hs_signup_userId',
                'hs_signup_loggedIn',
            ].forEach((key) => sessionStorage.removeItem(key));
        } catch {
            // ignore
        }
    };

    return (
        <SignupContext.Provider
            value={{
                APIformData,
                setAPIFormData,
                userName,
                setUserName,
                otp,
                setOtp,
                isOtpSent,
                setIsOtpSent,
                userId,
                setUserId,
                isLoggedIn,
                setIsLoggedIn,
                clearSignup,
            }}
        >
            {children}
        </SignupContext.Provider>
    );
};
